import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import hexToRgba from 'hex-to-rgba'
import get from 'lodash/get'
import throttle from 'lodash/throttle'
import Droppable from '@client/components/DroppableWrapper'
import { BLOCK_TYPES } from '@client/components/Block/constants'
import EditorModel, { NULL as EditorModelNULL } from './model'
import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import { errorDialogModel } from '@client/components/ErrorDialog/model'
import Preview from '@client/components/Preview/model'
import Item from '@client/components/Item'
import { ITEM_TYPE_FORM } from './settings'

import './styles.scss'

const acceptTypes = [BLOCK_TYPES.SECTION]

export class Editor extends Component {
  static propTypes = {
    editor: PropTypes.instanceOf(EditorModel),
    app: PropTypes.instanceOf(AppModel),
    serverRender: PropTypes.bool,
  }

  static defaultProps = {
    editor: EditorModelNULL,
    app: AppModelNULL,
    serverRender: false,
  }

  onShowPreviewClick = throttle(() => {
    this.props.editor.save()
    Preview.setShowPreview(true)
  }, 1000)

  render() {
    const { editor, app } = this.props
    const { columns, settings } = editor

    const column = Array.isArray(columns) && columns.length
      ? columns[0]
      : undefined

    if (!column) {
      return null
    }

    const mailEditorWrapperStyles =
      editor.kind && editor.kind !== ITEM_TYPE_FORM
        ? {
            backgroundColor: hexToRgba(settings.values.backgroundColor),
          }
        : undefined

    const { formatMessage } = app

    return (
      <>
        <div className="gan-editor-toolbar">
          <div className="bp6-button-group gan-view-mode-toggle">
            <button
              className={`bp6-button bp6-icon-desktop ${editor.viewMode !== 'mobile' ? 'bp6-active' : ''}`}
              onClick={() => editor.setViewMode('desktop')}
              aria-label={formatMessage('header.desktopView')}
              aria-pressed={editor.viewMode !== 'mobile'}
            >
              {formatMessage('header.desktopView')}
            </button>
            <button
              className={`bp6-button bp6-icon-mobile-phone ${editor.viewMode === 'mobile' ? 'bp6-active' : ''}`}
              onClick={() => editor.setViewMode('mobile')}
              aria-label={formatMessage('header.mobileView')}
              aria-pressed={editor.viewMode === 'mobile'}
            >
              {formatMessage('header.mobileView')}
            </button>
          </div>
          <button
            onClick={this.onShowPreviewClick}
            className="bp6-button bp6-minimal bp6-icon-eye-open gan-editor-toolbar__preview"
            disabled={errorDialogModel.error.show}
          >
            {formatMessage('header.previewBtn')}
          </button>
        </div>
        <div
          className={`${
            editor.kind ? editor.kind.toLowerCase() : 'mail'
          }-editor-wrapper ${!!get(app, 'wizard.type') ? 'has-wizard' : ''} ${editor.viewMode === 'mobile' ? 'mobile-view' : ''}`}
          style={mailEditorWrapperStyles}
        >
        <div
          className={`${
            editor.kind ? editor.kind.toLowerCase() : 'mail'
          }-editor ${editor.form_type || 'popup'}`}
          style={editor.form_type === 'popup' ? {
            background: hexToRgba(editor.settings.values.backgroundColor),
          } : undefined}
          data-style={editor.form_type === 'popup' ? editor.settings.values.backgroundColor : undefined}
        >
          {editor.kind === ITEM_TYPE_FORM && (
            <div className={`form-container ${editor.form_type || 'popup'}`}>
              <div
                className="form-container-inner"
                style={
                  editor.kind === ITEM_TYPE_FORM
                    ? {
                        // Mobile view's CSS clamps the popup to 375px — leave width
                        // unset there so the inline value doesn't outrank the rule.
                        width:
                          editor.viewMode !== 'mobile' && editor.popupWidth
                            ? `${editor.popupWidth}px`
                            : undefined,
                        borderRadius: editor.settings.values.popup_borderRadius
                          ? `${editor.settings.values.popup_borderRadius}px`
                          : undefined,
                      }
                    : undefined
                }
              >
                <div
                  className="form-section-one"
                  style={{
                    borderRadius: editor.settings.values.popup_borderRadius
                      ? `${editor.settings.values.popup_borderRadius}px`
                      : undefined,
                  }}
                >
                  <Droppable
                    model={column}
                    acceptTypes={acceptTypes}
                    kind={editor.kind}
                    subKind={editor.subKind}
                  >
                    <Item />
                  </Droppable>
                </div>
              </div>
            </div>
          )}
          {editor.kind !== ITEM_TYPE_FORM && (
            <Droppable
              model={column}
              acceptTypes={acceptTypes}
              kind={editor.kind}
              subKind={editor.subKind}
            >
              <Item />
            </Droppable>
          )}
        </div>
      </div>
      </>
    )
  }
}

export default inject('editor', 'app', 'serverRender')(observer(Editor))
